export default "__VITE_ASSET__CHNJ_5GG__"